import { useParams } from 'react-router-dom';
import config from '../../../config/config';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import Toast from '../../../../core/components/core/Util/Toast/Toast';
import Fetch from '../../../../core/util/core/Fetch';

function Contacts() {
    const { id } = useParams();

    const pathFrontEnd = '/gci/suppliers/';
    const pathBackEnd = config.endpoints.backend + 'gci/suppliers/';

    const paths = {
        endpoint: `${pathBackEnd}getContactsBySupplierId`,
        endpointDelete: `${pathBackEnd}deleteContact`,
        endpointSave: `${pathBackEnd}saveContact`,
        endpointGetById: `${pathBackEnd}getByContactId`,
        urlGoBack: `${pathFrontEnd}list`
    };

    const labels = {
        labelTitleEdit: 'Editar Contato',
        labelTitleView: 'Visualizar Contato',
        labelTitleAdd: 'Novo Contato'
    };

    const form = {
        containerType: 'dialog',
        validateOnChange: true,
        hiddenValues: {
            supplier_id: id
        },
        fields: [
            {
                label: 'Nome',
                type: 'text',
                name: 'name',
                validations: { required: true }
            },
            {
                label: 'Função',
                type: 'text',
                name: 'role',
                validations: { required: false }
            },
            {
                label: 'E-mail',
                type: 'email',
                name: 'email',
                validations: { required: false }
            },
            {
                label: 'Tipo de Telefone',
                type: 'select',
                options: [
                    { label: 'Tel. Fixo', value: 'TELFIXO' },
                    { label: 'Celular', value: 'CELULAR' },
                    { label: 'Comercial', value: 'COMERCIAL' },
                    { label: 'Tel. Institucional', value: 'TELINSTITUCIONAL' },
                    { label: 'Recado', value: 'RECADO' }
                ],
                name: 'phone_type',
                validations: { required: false }
            },
            {
                label: 'Telefone',
                type: 'phone',
                name: 'phone',
                validations: { required: false }
            }
        ],
        ...paths,
        ...labels
    };

    const list = {
        type: 'dialog',
        labelTitle: 'Lista de Contatos',
        handleConfirmDelete: async (item) => {
            const response = await Fetch.delete(paths.endpointDelete, { contact_id: item.id, id });
            const { status } = response;
            if (status === 0) {
                Toast.error('Erro ao deletar o contato');
                return false;
            }
            Toast.success('Contato deletado com sucesso');
        },
        filter: { id },
        fieldsShowOnDelete: ['name'],
        columns: [
            { name: 'name', label: 'Nome' },
            { name: 'role', label: 'Função' },
            { name: 'email', label: 'E-mail' },
            { name: 'phone', label: 'Telefone' }
        ],
        ...paths,
        ...labels
    };

    list.form = form;

    return (
        <CustomListContainer
            labelTitle={list.labelTitle}
            labelTitleButtonAdd={list.labelTitleAdd}
            list={list}
            form={form}
            showInnerModal={false}
            content={<CustomList list={list} />}
        />
    );
}

export default Contacts;
